exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-6d83f844]{border-radius:5px}", ""]);

// exports
